// src/pages/About.tsx
import React from 'react'; 
import PricingSection from '../../sections/PricingSection/PricingSection'; 
import './MembershipPage.css';

const MembershipPage: React.FC = () => { 

  return (
    <div className="about-container">
 
      <PricingSection/>
    </div>
  );
};

export default MembershipPage;
